import forDevice from '../../hoc/for-device';
import CommentMobile from './comment-mobile/comment-mobile';
import CommentDesktop from './comment-desktop/comment-desktop';
export const Comment = forDevice(CommentMobile, CommentDesktop);
export * from './comment-deleted/comment-deleted';
//# sourceMappingURL=index.js.map